import React, { useState } from 'react';
import { useData } from '../../data/DataProvider';
import { useToast } from '../../shared/components/ToastProvider';
import { date } from '../../shared/formatters';
import { portalApi } from '../../lib/api';

export default function NotificationSettings() {
  const { data, refresh, updateCollection } = useData();
  const { notify } = useToast();
  const [form, setForm] = useState({
    ...data.settings.notifications,
    review_url: data.settings.reviews?.google_review_url || '',
    review_enabled: Boolean(data.settings.reviews?.enabled),
    review_delay: data.settings.reviews?.delay_hours ?? 4,
  });
  const [testing, setTesting] = useState(false);

  const test = async () => {
    setTesting(true);
    try {
      const result = await portalApi.sendTestNotification();
      const counts = (result.results || [])
        .map((item) => `${item.channel}:${item.status}`)
        .join(', ');
      notify(counts ? `Test result — ${counts}` : 'Test notification sent');
      // Delay refresh to avoid disrupting the toast
      setTimeout(() => refresh().catch(() => {}), 1000);
    } catch (err) {
      notify(err.message || 'Test notification failed', 'error');
    } finally {
      setTesting(false);
    }
  };

  const save = () => {
    updateCollection('settings', {
      ...data.settings,
      notifications: {
        telegram_chat_id: form.telegram_chat_id,
        email: form.email,
        sms_enabled: form.sms_enabled,
      },
      reviews: {
        google_review_url: form.review_url,
        enabled: form.review_enabled,
        delay_hours: Number(form.review_delay) || 4,
      },
    });
    notify('Notification settings saved');
  };

  return <section className="panel settings-form">
    <h3>Notification settings</h3>
    <label>Telegram chat ID<input value={form.telegram_chat_id} onChange={(event) => setForm({ ...form, telegram_chat_id: event.target.value })} /></label>
    <label>Notification email<input value={form.email} onChange={(event) => setForm({ ...form, email: event.target.value })} /></label>
    <label><input type="checkbox" checked={form.sms_enabled} onChange={(event) => setForm({ ...form, sms_enabled: event.target.checked })} /> SMS escalation only</label>
    <button className="secondary-button" onClick={test} disabled={testing}>{testing ? 'Sending test…' : 'Send test notification'}</button>
    <button className="primary-button" onClick={save}>Save settings</button>

    <div className="form-section">
      <div className="form-section-head"><strong>Google review requests</strong></div>
      <p className="field-hint">After a job is completed, automatically email the client a link to leave you a Google review (clicks are tracked under Reviews in the sidebar).</p>
      <label><input type="checkbox" checked={form.review_enabled} onChange={(event) => setForm({ ...form, review_enabled: event.target.checked })} /> Send review requests after job completion</label>
      <label>Google review link<input value={form.review_url} onChange={(event) => setForm({ ...form, review_url: event.target.value })} placeholder="https://g.page/your-business/review" /></label>
      <label>Delay after completion (hours)<input type="number" min="0" step="1" value={form.review_delay} onChange={(event) => setForm({ ...form, review_delay: event.target.value })} /></label>
    </div>

    <div className="notification-history">{data.notification_log.map((item) => <div key={item.id}><span>{item.channel}</span><span>{item.recipient}</span><span>{item.status}</span><small>{date(item.created_at)}</small></div>)}</div>
  </section>;
}
